import { BACKEND } from "../variables.js";
import axios from "axios";

const SMS_PLACEHOLDERS = BACKEND + "/sms/placeholders";
const SMS_PREVIEW = BACKEND + "/sms/preview";
const SMS_SEND = BACKEND + "/sms/send";
const SMS_LIST_BY_HOUSE = BACKEND + "/sms/listByHouse";

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    GET_SMS_PLACEHOLDERS(state, payload) {
      return axios({
        method: "POST",
        url: SMS_PLACEHOLDERS,
        data: payload?.data || {},
        headers: { Authorization: payload.token },
      });
    },
    PREVIEW_SMS(state, payload) {
      return axios({
        method: "POST",
        url: SMS_PREVIEW,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    SEND_SMS(state, payload) {
      return axios({
        method: "POST",
        url: SMS_SEND,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    LIST_SMS_BY_HOUSE(state, payload) {
      return axios({
        method: "POST",
        url: SMS_LIST_BY_HOUSE,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
  },
};
